export default function VideoSection() {
  return (
    <section id="videos" className="bg-[#0d0d18] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <div
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-purple-500/50 mb-4"
              style={{ background: 'rgba(168,85,247,0.12)' }}
            >
              <i className="ri-youtube-line text-yellow-400 text-sm"></i>
              <span className="text-yellow-400 text-xs font-black uppercase tracking-widest">Latest Discoveries</span>
            </div>
            <h2
              className="font-black text-white text-3xl md:text-4xl"
              style={{ textShadow: '0 0 20px rgba(168,85,247,0.5)', fontFamily: "'Orbitron', sans-serif" }}
            >
              Watch Our Secret Findings
            </h2>
          </div>
          <a
            href="https://www.youtube.com/@ThekidsRobloxsecrets"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 border-2 border-yellow-400/60 text-yellow-400 font-black text-sm uppercase tracking-wider px-5 py-2.5 rounded-full whitespace-nowrap transition-all duration-200 hover:bg-yellow-400 hover:text-black"
            style={{ boxShadow: '0 0 16px rgba(250,204,21,0.3)' }}
          >
            <i className="ri-youtube-line text-lg"></i>
            Visit Our Channel
          </a>
        </div>

        {/* Coming Soon Placeholder */}
        <div
          className="flex flex-col items-center justify-center gap-6 py-16 md:py-24 rounded-2xl border-2 border-dashed border-purple-800/50"
          style={{ background: 'rgba(168,85,247,0.05)' }}
        >
          <div
            className="w-20 h-20 flex items-center justify-center rounded-full border-2 border-purple-600/40"
            style={{ background: 'rgba(168,85,247,0.1)', boxShadow: '0 0 30px rgba(168,85,247,0.3)' }}
          >
            <i className="ri-video-add-line text-yellow-400 text-4xl" style={{ filter: 'drop-shadow(0 0 8px rgba(250,204,21,0.8))' }}></i>
          </div>
          <div className="text-center">
            <p
              className="text-white font-black text-xl md:text-2xl mb-2"
              style={{ fontFamily: "'Orbitron', sans-serif", textShadow: '0 0 16px rgba(168,85,247,0.5)' }}
            >
              Videos Coming Soon… 🎬
            </p>
            <p className="text-gray-500 text-sm md:text-base">
              New secret discoveries dropping very soon. Stay tuned!
            </p>
          </div>
          <a
            href="https://www.youtube.com/@ThekidsRobloxsecrets"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-yellow-400/50 text-yellow-400 text-sm font-black uppercase tracking-wider transition-all duration-200 hover:bg-yellow-400 hover:text-black whitespace-nowrap"
            style={{ background: 'rgba(250,204,21,0.08)', boxShadow: '0 0 20px rgba(250,204,21,0.2)' }}
          >
            <i className="ri-youtube-line text-lg"></i>
            Subscribe on YouTube
          </a>
        </div>
      </div>
    </section>
  );
}
